import { useNavigate } from "react-router-dom";
import { ButtonEdit, ButtonDetail, ButtonDelete } from "../common/Button"
import { formatDate,getUniqNewsUrl,getLimitedDetailText } from "../common/BaseUtil"

//icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons'; 

export function BlogCardAdmin(props) {
    return (
        <div class="card" key={props.index} style={{ marginTop: '15px', marginBottom: '15px' }}>
            <div class="card-body">
                <h4 class="card-title" style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold' }}>{props.object.blogTitle}</h4>
                <p class="card-text">{getLimitedDetailText(props.object.blogContent.replace( /(<([^>]+)>)/ig, '').replace(/&nbsp;/g, ' '))}</p>
                <p class="card-text mt-auto" style={{fontSize:'13px'}}><FontAwesomeIcon icon={faClock}/> {formatDate(props.object.updateAt)}</p>
                <ButtonDetail id={props.object.id} url={"/blog_admin?id="}/>
                <ButtonEdit id={props.object.id} url={"/blog_modi_admin?id="}/>
                <ButtonDelete id={props.object.id} url={"/delete/blog"} objTitle={props.object.blogTitle}/>
            </div>
        </div> 
    );
}